import { render } from "./GlLoader.vue?vue&type=template&id=dbff4282&scoped=true"
import script from "./GlLoader.vue?vue&type=script&lang=js"
export * from "./GlLoader.vue?vue&type=script&lang=js"

import "./GlLoader.vue?vue&type=style&index=0&id=dbff4282&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dbff4282"

export default script